/**
 * When Rain Shoe Cover + a mapped rain jacket are both in the cart,
 * remove both and add the configured combo product (1:1 mapping).
 * Combo variants are Jacket size × Shoe cover size (e.g. "M / L" on labels).
 * Line properties also keep Jacket size + Shoe cover size on cart/order.
 */
(function () {
  if (window.__biShoeCoverBundleInit) return;
  window.__biShoeCoverBundleInit = true;

  var cfgEl = document.getElementById('shoe-cover-bundle-config');
  if (!cfgEl) return;

  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }

  var shoeVariantIds = Object.create(null);
  var shoeSizeByVariantId = Object.create(null);
  (cfg.shoeCover && cfg.shoeCover.variants ? cfg.shoeCover.variants : []).forEach(function (v) {
    shoeVariantIds[String(v.id)] = true;
    if (v.size != null) shoeSizeByVariantId[String(v.id)] = String(v.size);
  });
  var shoeProductId = cfg.shoeCover && cfg.shoeCover.productId != null ? String(cfg.shoeCover.productId) : null;

  var pairsByJacket = Object.create(null);
  (cfg.pairs || []).forEach(function (pair) {
    if (!pair || pair.jacketProductId == null) return;
    pairsByJacket[String(pair.jacketProductId)] = pair;
  });

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var pending = false;

  function cartUrl(path) {
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function fetchCart() {
    return fetch(cartUrl('cart.js'), { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function postJson(path, body) {
    return fetch(cartUrl(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }

  function isShoeLine(item) {
    if (shoeVariantIds[String(item.variant_id)]) return true;
    return shoeProductId && String(item.product_id) === shoeProductId;
  }

  function findShoeLines(cart) {
    return (cart.items || []).filter(isShoeLine);
  }

  function findMappedJacketLines(cart) {
    return (cart.items || []).filter(function (item) {
      return !!pairsByJacket[String(item.product_id)];
    });
  }

  function comboVariantForJacket(item, shoeSize) {
    var pair = pairsByJacket[String(item.product_id)];
    if (!pair || !pair.variantMap) return null;
    var mapped = pair.variantMap[String(item.variant_id)];
    if (mapped == null) return null;
    // Nested map: jacketVariantId -> { L: comboVid, XL: comboVid }
    if (typeof mapped === 'object') {
      var sizeKey = shoeSize || 'L';
      var nested = mapped[sizeKey] || mapped.L || mapped.XL;
      return nested != null ? Number(nested) : null;
    }
    // Legacy flat map fallback
    return Number(mapped);
  }

  function sizeFromLine(item) {
    if (!item) return '';
    if (item.variant_title && item.variant_title !== 'Default Title') return String(item.variant_title);
    if (item.variant_options && item.variant_options[0]) return String(item.variant_options[0]);
    if (item.options_with_values && item.options_with_values[0] && item.options_with_values[0].value) {
      return String(item.options_with_values[0].value);
    }
    return shoeSizeByVariantId[String(item.variant_id)] || '';
  }

  function propsForCombo(jacketSize, shoeSize) {
    var props = {};
    if (jacketSize) props['Jacket size'] = jacketSize;
    if (shoeSize) props['Shoe cover size'] = shoeSize;
    return props;
  }

  function changeQty(key, quantity) {
    return postJson('cart/change.js', { id: key, quantity: quantity });
  }

  function addItems(items) {
    return postJson('cart/add.js', { items: items });
  }

  function notifyCart(cart) {
    try {
      document.dispatchEvent(
        new CustomEvent('cart:change', { detail: { cart: cart, baseEvent: 'shoe-cover-bundle' } })
      );
    } catch (e) {}
    if (typeof window.refreshCartDrawer === 'function') {
      try {
        window.refreshCartDrawer();
      } catch (e) {}
    }
  }

  /**
   * Pair each mapped jacket unit with one shoe-cover unit.
   * Leftover jackets or shoe covers stay in the cart.
   */
  async function reconcile() {
    if (busy) {
      pending = true;
      return;
    }
    busy = true;
    window.__biSkipGokwikOpen = true;

    try {
      var cart = await fetchCart();
      var shoeLines = findShoeLines(cart);
      var jacketLines = findMappedJacketLines(cart);
      if (!shoeLines.length || !jacketLines.length) return;

      // Expand shoe units in order so each jacket unit can take a shoe size
      var shoeUnits = [];
      shoeLines.forEach(function (line) {
        var size = sizeFromLine(line) || shoeSizeByVariantId[String(line.variant_id)] || '';
        for (var q = 0; q < (line.quantity || 0); q++) {
          shoeUnits.push({ key: line.key, size: size, line: line });
        }
      });
      if (!shoeUnits.length) return;

      var shoeUnitIndex = 0;
      var jobs = Object.create(null);
      var jacketRemovals = [];

      for (var i = 0; i < jacketLines.length && shoeUnitIndex < shoeUnits.length; i++) {
        var jacket = jacketLines[i];
        var jacketSize = sizeFromLine(jacket);
        var take = Math.min(jacket.quantity || 0, shoeUnits.length - shoeUnitIndex);
        if (take < 1) continue;

        var paired = 0;
        for (var t = 0; t < take; t++) {
          var shoeUnit = shoeUnits[shoeUnitIndex];
          var shoeSize = shoeUnit.size || '';
          var comboVid = comboVariantForJacket(jacket, shoeSize);
          if (!comboVid) break;
          shoeUnitIndex++;
          paired += 1;
          var jobKey = String(comboVid) + '|' + jacketSize + '|' + shoeSize;
          if (!jobs[jobKey]) {
            jobs[jobKey] = {
              comboVariantId: comboVid,
              qty: 0,
              jacketSize: jacketSize,
              shoeSize: shoeSize
            };
          }
          jobs[jobKey].qty += 1;
        }

        if (paired < 1) continue;

        jacketRemovals.push({
          key: jacket.key,
          lineQty: jacket.quantity || 0,
          removeQty: paired
        });
      }

      var jobKeys = Object.keys(jobs);
      if (!jobKeys.length) return;

      var shoesToRemove = shoeUnitIndex;

      for (var j = 0; j < jacketRemovals.length; j++) {
        var jk = jacketRemovals[j];
        var newQty = jk.lineQty - jk.removeQty;
        await changeQty(jk.key, newQty > 0 ? newQty : 0);
      }

      var leftToStrip = shoesToRemove;
      for (var s = 0; s < shoeLines.length && leftToStrip > 0; s++) {
        var shoe = shoeLines[s];
        var strip = Math.min(shoe.quantity || 0, leftToStrip);
        var shoeNew = (shoe.quantity || 0) - strip;
        await changeQty(shoe.key, shoeNew > 0 ? shoeNew : 0);
        leftToStrip -= strip;
      }

      var addPayload = jobKeys.map(function (key) {
        var job = jobs[key];
        return {
          id: job.comboVariantId,
          quantity: job.qty,
          properties: propsForCombo(job.jacketSize, job.shoeSize)
        };
      });
      await addItems(addPayload);

      cart = await fetchCart();
      notifyCart(cart);
    } catch (err) {
      console.warn('[shoe-cover-bundle]', err);
    } finally {
      busy = false;
      window.__biSkipGokwikOpen = false;
      if (pending) {
        pending = false;
        reconcile();
      }
    }
  }

  function scheduleReconcile() {
    setTimeout(function () {
      reconcile();
    }, 50);
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function () {
      var input = arguments[0];
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}

      var request = nativeFetch.apply(this, arguments);
      if (!/\/cart\/(add|change|update|clear)\.js/.test(url)) return request;
      if (busy) return request;

      return request.then(function (response) {
        scheduleReconcile();
        return response;
      });
    };
  }

  document.addEventListener('cart:change', function (event) {
    if (event.detail && event.detail.baseEvent === 'shoe-cover-bundle') return;
    scheduleReconcile();
  });
  document.addEventListener('variant:add', scheduleReconcile);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleReconcile);
  } else {
    scheduleReconcile();
  }
})();
